import { Geo } from './utils/geo.js';
import { Body } from './utils/body.js';
window.Geo = new Geo();
new Body();